import { css } from "styled-components";
import { Backdrop, BackdropBackground } from "../../../../components/Backdrop";
import { Media } from "../../../../components/Media";
export const riotProductSkin = () => css `
  & {
    ${Backdrop} {
      position: relative;

      ${BackdropBackground} {
        position: relative;

        ${Media} {
          position: relative;
          object-fit: cover;
        }
      }
    }
  }
`;
//# sourceMappingURL=index.js.map